import { render, staticRenderFns } from "./EDSSettingsDlg.vue?vue&type=template&id=c689fcec&"
import script from "./EDSSettingsDlg.vue?vue&type=script&lang=js&"
export * from "./EDSSettingsDlg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports